import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './plugin/element';
import {Message,MessageBox,Loading,Notification} from 'element-ui';
import axios from 'axios';
import loginout from './checkLogin/auto_loginout';
import md5 from 'js-md5';
import {mount} from './common/loginout';
import "./common/font/font.css";
import {apiFlag} from "./common/commonVariable";
import './plugin/anDesignVue';
import moment from 'moment';
// import ElementUI from "element-ui";

// Vue.use(ElementUI, {
//   size: 'small', // 默认大小
//   zIndex: 3000   // 弹出层的z-index值
// });

// 1为线上版本，2为本地版本，3为测试版本
let http={};
function getHttpFile(){
  if(apiFlag===1||apiFlag===3){
    http= require("./request/http");
    // http=await import("./request/http");
  }else if(apiFlag===2){
    http= require("./request/http11");
    // http=await import("./request/http11");
  }
}
getHttpFile();


Vue.config.productionTip = false;
Vue.prototype.$http=http;
Vue.prototype.$message=Message;
Vue.prototype.$confirm=MessageBox.confirm;
Vue.prototype.$loading=Loading.service;
Vue.prototype.$axios=axios;
Vue.prototype.$md5=md5;
Vue.prototype.$notify=Notification;
Vue.prototype.$alert=MessageBox.alert;
Vue.prototype.$apiFlag=apiFlag;
Vue.prototype.$moment=moment;
Vue.use(loginout);
Vue.use(mount);
// Vue.use(ElementUI);
Vue.directive('removeHidden',{
  bind(el){
    const ariaEl=el.querySelectorAll('.el-radio_original[aria-hidden]');
    ariaEl.forEach(item => {
      item.removeAttribute('aria-hidden');
    });
  }
});
Vue.directive("loading",{
  inserted:function(el,binding,vnode){
    if(binding.value){
      el.instance=Loading.service({
        lock:true,
        text:"加载中...",
        background:"rgba(0,0,0,0.7)"
      });
    }
  },
  update:function(el,binding,vnode){
    if(binding.value){
      el.instance.visible=true;
    }else{
      el.instance.close();
    }
  },
  unbind:function(el,binding,vnode){
    if(el.instance){
      el.instance.close();
    }
  }
});
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');

// 全局配置
// router.beforeEach((to, from, next) => {
//   if (to.meta.requiresAuth) {
//     if (store.state.userInfo.yhid) {
//       // 需要登录后查看的页面判断user是否登录
//       next();
//     } else {
//       Vue.prototype.$message({
//         type: "warning",
//         message: "您还没有登录，请先登录系统",
//         duration: "1000"
//       });
//       next("/");
//     }
//   } else {
//     next();
//   }
// });
// router.afterEach((to, from) => {
//   /* 路由发生变化修改页面title */
//   if (to.meta.title) {
//     document.title = to.meta.title;
//   }
// });
